import * as React from 'react';
import Section from '../../components/Section';
import {
  Text,
  Select,
  TextArea,
  Checkbox,
  CompanySelect,
  Image,
} from '../../components/forms';
import { methods, Guide } from '../../guide';
import HelpHint from '../../components/HelpHint';
import { ProfileContext, ProfileManager } from '../../profile';
import GuideGraph from '../../components/GuideGraph';

export interface BasicDetailsProps {
  guide: Guide;
  onChange: Function;
}

const setValue = (obj: Guide, onChange: Function) => (
  field: string,
  newValue: String,
) =>
  onChange(
    Object.assign({}, obj, {
      [field]: newValue,
    }),
  );

const canCreateBrandedGuide = (context: ProfileManager): boolean => {
  return context.profile.company_id !== null;
};

export const BasicDetails = (props: BasicDetailsProps) => (
  <React.Fragment>
    <Section title="Select the brew method">
      <div className="flex flex-wrap">
        <div className="flex-auto w-70-ns w-100 pr2">
          <Select
            label="Brew Method"
            field={['method']}
            id="method"
            options={methods}
            defaultValue={props.guide.method}
            onValueChange={setValue(props.guide, props.onChange)}
          />
          {canCreateBrandedGuide(React.useContext(ProfileContext)) && (
            <CompanySelect
              label="Company"
              field={['company_id']}
              id="company_id"
              defaultValue={props.guide.company_id}
              onValueChange={setValue(props.guide, props.onChange)}
            />
          )}
        </div>
        <div className="flex-auto w-30-ns w-100 pl2">
          <GuideGraph guide={props.guide} />
        </div>
      </div>
    </Section>
    <Section title="Add general information">
      <div className="flex flex-wrap">
        <div className="flex-auto w-70-ns w-100 pr2">
          <Text
            label="Name"
            field={['name']}
            id="name"
            defaultValue={props.guide.name}
            onValueChange={setValue(props.guide, props.onChange)}
          />
          <TextArea
            label="Description"
            field={['description_text']}
            id="description_text"
            defaultValue={props.guide.description_text}
            onValueChange={setValue(props.guide, props.onChange)}
          />
          <Image
            label="Image"
            field={['image_identifier']}
            id="image_identifier"
            defaultValue={props.guide.image_identifier}
            onValueChange={setValue(props.guide, props.onChange)}
          />
          <Checkbox
            label="Published?"
            field={['shared']}
            id="shared"
            defaultValue={props.guide.shared}
            onValueChange={setValue(props.guide, props.onChange)}
            tooltip="Display this brew guide in the 'Discover' section"
          />
        </div>
        <div className="flex-auto w-30-ns w-100 pl2">
          <HelpHint>
            Note: Name and description should best describe the reason or story
            behind this particular way of brewing.
          </HelpHint>
        </div>
      </div>
    </Section>
  </React.Fragment>
);

export default BasicDetails;
